module.exports = __webpack_public_path__ + "img/11.abdea907.jpg";